import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import * as Style from '../components/styled-components/Myhhs'
import Grid from '@mui/material/Grid'
import { ThemeProvider } from '@mui/material/styles'
import { Divider, Select, MenuItem, Link, Container, Box, InputAdornment } from '@mui/material'
import massHealthLogo from '../assets/images/massHealth.png'
import '../styles/header.scss'
import { useLocation, Link as RouterLink } from 'react-router-dom'
import Footer from './Footer'
import { themeLayout, logout, BoxWrapper } from '../components/Style'
import config from 'config/config'
import { connect } from 'react-redux'
import { getLanguage, changeLanguage, showFeedBack } from '../store/actions/languageActions'
import { useMsal } from '@azure/msal-react'
import ReactGA from 'react-ga4'
import { getClientInfo, azureLogOut } from '../store/actions/auth'
import Language from '../assets/images/Language.svg'
import Settings from '../assets/images/Settings.svg'
import Logout from '../assets/images/Logout.svg'
import Profile from '../assets/images/MyInfo-icon-old.svg'
import KeyValueDivider from '../components/KeyValueDivider'

const MainLayout = (props) => {
  const location = useLocation()
  const selectedLanguage = props?.langDetails?.currentLanguage
  const [layout, setLayout] = useState(props?.langDetails?.constantStrings)
  const [select, setSelect] = useState(false)
  const [myAccount, setMyAccount] = useState(false)

  const { instance } = useMsal()
  const lang = props.langDetails.currentLanguage
  const userInfo = props?.authDetails?.loginDetails?.data
  const accountDetails = {
    first_name: userInfo?.firstName,
    last_name: userInfo?.lastName,
    emailAddress: userInfo?.emailAddress
  }
  useEffect(() => {
    setLayout(props?.langDetails?.constantStrings)
  }, [JSON.stringify(props?.langDetails), lang])

  useEffect(() => {
    if (typeof props?.authDetails?.loginDetails?.data?.firstName !== 'string') {
      props?.getClientInfo(instance)
    }
  }, [])

  const activeMenu = location.pathname.slice(1).split('/')[0]

  const signOutClickHandler = () => {
    ReactGA.event({ category: 'Logout', action: 'Logout', label: 'Logout' })
    props.azureLogOut(instance)
  }

  const onLanguageSelection = (e) => {
    ReactGA.event({ category: 'Language selector', action: 'Selected Language', label: e.target.value })
    localStorage.setItem('language', e.target.value)
    // window.location.reload()
    props.changeLang(e.target.value)
  }
  return (
    <ThemeProvider theme={themeLayout}>
      <Grid container sx={{ background: activeMenu.toLowerCase() === 'dashboard' ? config.colors.white : config.colors.verylightshadegray }} className="layoutContainer">
        <Grid container className="layoutInnerContainer">
        <Grid container
            item
            className="logoOuterGrid"
            xs={2}
            lg={7.5}
            md={7.5}>
            <Grid className="logoGrid cursor-pointer">
              <Link component={RouterLink} to={props?.logoClick}>
                <img src={massHealthLogo} height="64" width="65" alt="Home of MyServices" />
              </Link>
            </Grid>
          </Grid>
          <Grid container
            item
            justifyContent={'flex-end'}
            display="flex"
            className="languageGrid-landing"
            xs={10}
            lg={12}
            md={12}
            textAlign={'right'}>
            <Grid item display={{ xs: 'none', sm: 'none', xl: 'flex', lg: 'flex', md: 'none' }} className="demo-simple-select topMenuLink textCenterAlign">
              <Select labelId="label" id="lanuageSelect" value={selectedLanguage} sx={logout} MenuProps={{ style: { maxWidth: 0, maxHeight: 300, position: 'absolute' }, disableScrollLock: true }}
               startAdornment={
                <InputAdornment position='start' >
                  <img src={Language} alt={'select language'} height="19" width="19" className='iconStyle' />
                </InputAdornment>
               }
               onChange={onLanguageSelection}>
                {
                  config.languages.map((item, i) => {
                    return <MenuItem key={i} value={item.value} >
                      {item.key}
                    </MenuItem>
                  })
                }
              </Select>
            </Grid>
            {props?.showProfile && <Grid className="demo-simple-select textCenterAlign" style={{ marginLeft: 10 }}>
              <Select id="aaa" value={1} onClick={() => setSelect(!select)} open={select} className="blue" sx={logout} MenuProps={{ style: { maxWidth: 0, maxHeight: 300, position: 'absolute' }, disableScrollLock: true }}>
                <MenuItem value={1} style={{ display: 'none' }}>
                  <span className="cursor-pointer black textCenterAlign">
                    <img src={Profile} height="19" width="19" className='iconStyle' alt='Profile' />
                    <div className="t-decorate-underline name-spacing1" style={{ color: '#002a57' }}>{userInfo?.firstName}</div>
                  </span>
                </MenuItem>
                <><MenuItem value={2} onClick={() => { setMyAccount(true); setSelect(false) }} className="blue t-decorate-underline textCenterAlign">
                  <img src={Settings} height="16" width="16" style={{ marginRight: '5px' }} alt="Settings"/>{layout?.settings}
                </MenuItem><Divider /></>
                <MenuItem value={3} onClick={signOutClickHandler} className="blue t-decorate-underline"><img src={Logout} height="16" alt='Logout' width="16" style={{ marginRight: '5px' }} />{layout?.logout}</MenuItem>
              </Select>
            </Grid>}
          </Grid>
        </Grid>

        { myAccount && (
          <><Box sx={BoxWrapper} className="landing-height">
            <Grid
              container
              item
              display="flex"
              justifyContent="center"
            ><Grid item p={{ xs: 2, sm: 2, md: 2, xl: 2 }}>
                <Grid
                  container
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  xl={12}
                  display="flex"
                  justifyContent={{
                    xs: 'center',
                    sm: 'center',
                    md: 'flex-start',
                    xl: 'flex-start'
                  }}
                >
                  <Grid
                    item
                    sx={{ mt: 2, mb: 2 }}
                    maxWidth={{ xs: '405px', sm: '405px', md: '100%', xl: '100%' }}
                  >
                    <span className="font-20 font-weight gray">{layout?.myAccount}</span>
                  </Grid></Grid>
                <Grid container sx={{ pb: 2, pr: 2, backgroundColor: config.colors.white, borderRadius: '5px' }}>
                  <Grid item xs={12} lg={12} md={12} display="flex" justifyContent="flex-start" sx={{ p: 2 }}>
                    <KeyValueDivider data={accountDetails} language={props?.langDetails?.currentLanguage} />
                  </Grid>
                </Grid>
                <Grid item display="flex"
                  justifyContent={{
                    xs: 'center',
                    sm: 'center',
                    md: 'center',
                    xl: 'center'
                  }}
                  xs={12} lg={12} md={12} sx={{ mt: 2 }}>
                  <Style.MyhhsBlueButton fontSize="16px"
                    style={{ fontFamily: "'Source Sans Pro', sans-serif" }}
                    variant="contained"
                    sx={{ mt: 2, mb: 2 }} onClick={() => setMyAccount(false)}>
                    {layout?.back}
                  </Style.MyhhsBlueButton>

                </Grid>
              </Grid>
            </Grid>
          </Box><Container className="footer" sx={{ m: 0 }}>
              <Grid container className="footer-container" sx={[config.width59]}>
                <Footer />
              </Grid>
            </Container></>
        )}
        {!myAccount && (
        <>
            <Grid sx={{ mt: 2, background: activeMenu.toLowerCase() === 'dashboard' ? config.colors.white : config.colors.verylightshadegray }}
            item display="flex" justifyContent="center" className="spacing-mbl" xs={12} xl={12} lg={12} md={12}>
                <Style.Content>{props?.children}</Style.Content>
            </Grid>
            <Container className="footer" sx={{ m: 0 }}>
                <Grid container className="footer-container" sx={[config.width64]}>
                    <Footer />
                </Grid>
            </Container>
        </>
        )}
      </Grid>
    </ThemeProvider>
  )
}

const mapStateToProps = (state) => ({ langDetails: state.language, authDetails: state.auth, feedBackFlag: state.flag })

const mapDispatchToProps = (dispatch) => {
  return {
    onGetLanguage: (lang) => dispatch(getLanguage(lang)),
    azureLogOut: (instance) => dispatch(azureLogOut(instance)),
    getClientInfo: (msal) => dispatch(getClientInfo(msal)),
    changeLang: (lan) => dispatch(changeLanguage(lan)),
    feedBack: (flag) => dispatch(showFeedBack(flag))
  }
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  onGetLanguage: PropTypes.func,
  getClientInfo: PropTypes.func,
  langDetails: PropTypes.object,
  authDetails: PropTypes.object,
  azureLogOut: PropTypes.func,
  feedBackFlag: PropTypes.object,
  feedBack: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout)
